"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _locale = require("../locale");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ResetTokenButton = function ResetTokenButton(_ref) {
  var _theme$config$token;
  var theme = _ref.theme,
    tokenName = _ref.tokenName,
    style = _ref.style;
  var locale = (0, _locale.useLocale)();
  var showReset = (_theme$config$token = theme.config.token) === null || _theme$config$token === void 0 ? void 0 : _theme$config$token[tokenName];
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      display: 'inline-block'
    }, style)
  }, /*#__PURE__*/_react.default.createElement(_antd.Typography.Link, {
    style: {
      fontSize: 12,
      padding: 0,
      opacity: showReset ? 1 : 0,
      pointerEvents: showReset ? 'auto' : 'none'
    },
    onClick: function onClick() {
      var _theme$onAbort;
      return (_theme$onAbort = theme.onAbort) === null || _theme$onAbort === void 0 ? void 0 : _theme$onAbort.call(theme, ['token', tokenName]);
    }
  }, locale.reset));
};
var _default = exports.default = ResetTokenButton;